import { Component, Vue } from "vue-property-decorator";

import { LangManager } from "@/lang";
import { UserModel } from "@/models";
// import { pb } from "@/network/pb/proto";

@Component<ApUserIndexController>({
  components: {}
})
export default class ApUserIndexController extends Vue {
  private textHash!: { [page: string]: { [key: string]: string } };
  private data: object = {};

  public async created() {
    this.$data.textHash = LangManager.getTextHashByPage("user");
    this.$data.data = await UserModel.get();
  }

  private redirectToEditPage(index: number) {
    window.location.href = "/admin/user/edit/" + index;
  }

  private confirmDelete(index: number) {
    const yes = confirm("confirm delete id " + this.$data.data[index].id + "?");
    if (yes) {
      this.deleteForm(index);
    }
  }

  private async deleteForm(index: number) {
    const errNo = await UserModel.delete(this.$data.data[index].id);
    if (errNo === 1) {
      window.location.href = "/admin/user";
    }
  }

  // private async pbTest() {
  //   const test = pb.User.create({
  //     id: 1,
  //     account: "pb",
  //     password: "pbpb",
  //     name: "pb",
  //     role: "pb"
  //   });
  //   const testEncode = pb.User.encode(test).finish();
  //   await UserModel.addByPB(testEncode);
  // }
}
